import FAQs from './FAQs'
import ContactUs from './ContactUs'
import useScrollAnimation from './useScrollAnimation'
import { Container, Grid } from '@mui/material'

const SupportSection = () => {
  useScrollAnimation('.contact-us')

  return (
    <section id="contact-us" className="support-section pad-60">
      <Container>
        <Grid container justifyContent="center">
          <Grid
            item
            lg={6}
            md={6}
            sm={6}
            xs={12}
            className="d-flex flex-column align-items-center faq-part"
          >
            <FAQs />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={6}
            xs={12}
            className="d-flex flex-column justify-content-end form-part"
          >
            <ContactUs />
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default SupportSection
